import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const DrawingEditorToolSelectV2Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon drawing-editor-tool-select-v-2"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M7.478 15.139 3.061 3.926c-.177-.45-.266-.676-.218-.82a.42.42 0 0 1 .263-.263c.144-.048.37.04.82.218l11.213 4.417c.362.143.544.215.617.331a.42.42 0 0 1 .046.34c-.04.132-.196.249-.508.483l-2.378 1.784s2.588 2.64 4.167 4.166l-2.5 2.5-4.167-4.166-1.784 2.378c-.234.312-.351.468-.483.508a.42.42 0 0 1-.34-.046c-.116-.073-.188-.255-.33-.617Z"
        />
    </svg>
);
const Memo = memo(DrawingEditorToolSelectV2Icon);
export default Memo;
